import { render, staticRenderFns } from "./SessionsSubpage.vue?vue&type=template&id=581874d9&"
import script from "./SessionsSubpage.vue?vue&type=script&lang=js&"
export * from "./SessionsSubpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports